type IconProps = {
	src: string;
	size?: number;
	alt?: string;
	className?: string;
};

export default function Icon({
	src,
	size,
	alt = "",
	className = "",
}: IconProps) {
	return (
		<img src={src} alt={alt} width={size} height={size} className={className} />
	);
}
